import React from "react";
import { Stack, Switch, Typography } from "@mui/material";

interface SwitchSettingBarProps {
  title: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/**
 * Grey-bar setting toggle: title + helper on the left, switch on the right.
 */
const SwitchSettingBar: React.FC<SwitchSettingBarProps> = ({
  title,
  description,
  checked,
  onChange,
}) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    gap={2}
    sx={{
      bgcolor: (theme) => (theme.palette as any).grayscale?.[50] ?? "#F6F7F8",
      borderRadius: 2,
      px: 4,
      py: 3,
    }}
  >
    <Stack gap={1}>
      <Typography component="h3" variant="subtitle2">
        {title}
      </Typography>
      {description && (
        <Typography component="p" variant="caption" color="text.secondary">
          {description}
        </Typography>
      )}
    </Stack>
    <Switch
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      inputProps={{ "aria-label": title }}
    />
  </Stack>
);

export default SwitchSettingBar;
